import type React from "react";
import { useState } from "react";

import * as _ from "lodash";

import { swSettings } from "app/common/services/swSettings";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { AutocompleteDigitalMarketing } from "pro-features/components/AutocompleteDigitalMarketing/AutocompleteDigitalMarketing";

import { MajorNavigationTile } from "./components/MajorNavigationTile";
import { navigationTiles as navigationTilesConfig } from "./constants";
import {
    AutocompleteWrapper,
    HeaderContentContainer,
    HeaderSubtitle,
    HeaderTitle,
    HeaderTitleRow,
    HomepageBodyTextStyled,
    PageContainer,
    PrimaryHomepageHeaderStyled,
    TilesContainer,
    TilesGroup,
} from "./styledComponents";

const headerImageUrl = AssetsService.assetUrl("/images/secondary-home-page-header-light-small.png");
interface DigitalSuiteMarketingHomePageProps {
    onHomepageButtonClick: () => void;
}
export const DigitalSuiteMarketingHomePage: React.FC<DigitalSuiteMarketingHomePageProps> = (props) => {
    const [autocompleteOpen, setAutocompleteOpen] = useState<boolean>(false);
    const i18n = i18nFilter();
    const userFirstName = _.capitalize(swSettings.user.firstname);
    const userProductKey = swSettings.components.Home.resources.ProductKey;
    const tileFilter = (row) =>
        // if no userTypes were set
        row.userTypes == undefined ||
        // if user is not no touch
        userProductKey == null ||
        // if user is no touch and can view tile
        row.userTypes?.includes(userProductKey);

    const navigationTiles = navigationTilesConfig.filter(tileFilter);

    return (
        <PageContainer className="main-homepage-container">
            {/* @ts-expect-error - bgColor is not defined on the type (should be optional in ui-components) */}
            <PrimaryHomepageHeaderStyled imageUrl={headerImageUrl}>
                <HeaderContentContainer>
                    <div>
                        <HeaderTitleRow>
                            <HeaderTitle>
                                {i18n("digitalsuite.homepage.header.title", {
                                    name: userFirstName,
                                })}
                            </HeaderTitle>
                        </HeaderTitleRow>
                        <HeaderSubtitle>{i18n("digitalmarketing.homepage.header.subtitle")}</HeaderSubtitle>
                    </div>
                    <AutocompleteWrapper>
                        <AutocompleteDigitalMarketing
                            includeKeywordsData
                            maxCompareItemsToDisplay={1}
                            onAutocompleteOpen={() => setAutocompleteOpen(true)}
                            onAutocompleteClose={() => setAutocompleteOpen(false)}
                        />
                    </AutocompleteWrapper>
                </HeaderContentContainer>
            </PrimaryHomepageHeaderStyled>
            <TilesGroup>
                <HomepageBodyTextStyled>
                    {i18n("digitalmarketing.homepage.featured.tiles.title")}
                </HomepageBodyTextStyled>
                <TilesContainer tilesPerRow={4}>
                    {navigationTiles.map((tile) => (
                        <MajorNavigationTile
                            key={tile.title}
                            {...tile}
                        />
                    ))}
                </TilesContainer>
            </TilesGroup>
        </PageContainer>
    );
};
